import { render, staticRenderFns } from "./transaction-inbound.vue?vue&type=template&id=47d5e594&"
import script from "./transaction-inbound.vue?vue&type=script&lang=js&"
export * from "./transaction-inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports